import PROFILE_PERMISSION_KEYS from '../../../../permissions/profile.permissions';
import { REMOTE_PROFILE_PERMISSION_KEYS } from '../../../../permissions/remote.permissions';

// todo: back, propose, invest etc: reasons should be more specific.  e.g. 'SELF', 'EXISTS'
// todo: add 'view-public' 'view-protected' 'view-private' to the profile permissions served by api
export default ({ remotePermissions: p }) => ({
  [PROFILE_PERMISSION_KEYS.EDIT_PROFILE]: () => p?.[REMOTE_PROFILE_PERMISSION_KEYS.EDIT_PROFILE],
  [PROFILE_PERMISSION_KEYS.VIEW_PUBLIC_PROFILE]: () => {
    const allowed = p?.[REMOTE_PROFILE_PERMISSION_KEYS.VIEW_PROFILE]?.allowed
      && p?.[REMOTE_PROFILE_PERMISSION_KEYS.VIEW_PROFILE]?.reason !== 'BLOCKED';
    return {
      allowed,
      ...p?.[REMOTE_PROFILE_PERMISSION_KEYS.VIEW_PROFILE],
    };
  },
  [PROFILE_PERMISSION_KEYS.VIEW_PROTECTED_PROFILE]: () => p?.[REMOTE_PROFILE_PERMISSION_KEYS.VIEW_PROFILE],
  [PROFILE_PERMISSION_KEYS.VIEW_PRIVATE_PROFILE]: () => p?.[REMOTE_PROFILE_PERMISSION_KEYS.EDIT_PROFILE],
  [PROFILE_PERMISSION_KEYS.CAN_PROPOSE]: () => p?.[REMOTE_PROFILE_PERMISSION_KEYS.CAN_PROPOSE],
  [PROFILE_PERMISSION_KEYS.CAN_BACK]: () => p?.[REMOTE_PROFILE_PERMISSION_KEYS.CAN_BACK],
  [PROFILE_PERMISSION_KEYS.CAN_INVEST]: () => p?.[REMOTE_PROFILE_PERMISSION_KEYS.CAN_INVEST],
  [PROFILE_PERMISSION_KEYS.CAN_MEET]: () => p?.[REMOTE_PROFILE_PERMISSION_KEYS.CAN_MEET],
  [PROFILE_PERMISSION_KEYS.CAN_POST_TO_PROFILE]: () => p?.[REMOTE_PROFILE_PERMISSION_KEYS.VIEW_PROFILE],
  [PROFILE_PERMISSION_KEYS.REPORT_USER]: () => {
    if (p?.[REMOTE_PROFILE_PERMISSION_KEYS.EDIT_PROFILE]?.allowed) {
      return {
        allowed: false,
        reason: 'SELF',
      };
    }

    return {
      allowed: true,
    };
  },
  [PROFILE_PERMISSION_KEYS.BLOCK_USER]: () => {
    if (p?.[REMOTE_PROFILE_PERMISSION_KEYS.EDIT_PROFILE]?.allowed) {
      return {
        allowed: false,
        reason: 'SELF',
      };
    }

    return {
      allowed: true,
    };
  },
  [PROFILE_PERMISSION_KEYS.UNBLOCK_USER]: () => {
    if (p?.[REMOTE_PROFILE_PERMISSION_KEYS.EDIT_PROFILE]?.allowed) {
      return {
        allowed: false,
        reason: 'SELF',
      };
    }

    return {
      allowed: true,
    };
  },
  [PROFILE_PERMISSION_KEYS.VIEW_FULL_NAME]: () => p?.[REMOTE_PROFILE_PERMISSION_KEYS.VIEW_FULL_NAME],
});
